var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTimeclockinline = function SvgTimeclockinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "timeclock_inline_svg__Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 50 50"
    },
    viewBox: "3 0 50 50"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".timeclock_inline_svg__st1{fill:#00a98f}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "timeclock_inline_svg__XMLID_11844_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "timeclock_inline_svg__XMLID_9778_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "timeclock_inline_svg__XMLID_9779_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "timeclock_inline_svg__XMLID_9780_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "timeclock_inline_svg__XMLID_9781_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "timeclock_inline_svg__XMLID_9782_",
    d: "M36.2 29.2v5.2c0 .5-.4 1-1 1H14.4c-.5 0-1-.4-1-1v-19c0-.5.4-1 1-1h15.7c.5 0 1 .4 1 1 0 .5-.4 1-1 1H15.4v17.1h18.9v-4.2c0-.5.4-1 1-1 .5-.1.9.4.9.9z",
    className: "timeclock_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "timeclock_inline_svg__XMLID_9784_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "timeclock_inline_svg__XMLID_9785_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "timeclock_inline_svg__XMLID_9786_",
    d: "M27 18.2c0 .3-.2.5-.5.5h-9.6c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h9.6c.2.1.5.3.5.5z",
    className: "timeclock_inline_svg__st1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "timeclock_inline_svg__XMLID_9788_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "timeclock_inline_svg__XMLID_9789_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "timeclock_inline_svg__XMLID_9790_",
    d: "M21.9 21.5c0 .3-.2.5-.5.5h-4.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h4.5c.3.1.5.3.5.5z",
    className: "timeclock_inline_svg__st1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "timeclock_inline_svg__XMLID_9792_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "timeclock_inline_svg__XMLID_9793_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "timeclock_inline_svg__XMLID_9794_",
    d: "M25 24.8c0 .3-.2.5-.5.5h-7.6c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h7.6c.3 0 .5.2.5.5z",
    className: "timeclock_inline_svg__st1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "timeclock_inline_svg__XMLID_9796_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "timeclock_inline_svg__XMLID_9797_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "timeclock_inline_svg__XMLID_9798_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "timeclock_inline_svg__XMLID_9799_",
    d: "M20.8 27.9c0 .3-.2.5-.5.5h-3.4c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3.4c.3 0 .5.2.5.5z",
    className: "timeclock_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "timeclock_inline_svg__XMLID_9801_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "timeclock_inline_svg__XMLID_9802_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "timeclock_inline_svg__XMLID_9803_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "timeclock_inline_svg__XMLID_9804_",
    d: "M22.4 31.2c0 .3-.2.5-.5.5h-5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h5c.3 0 .5.3.5.5z",
    className: "timeclock_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "timeclock_inline_svg__XMLID_9806_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "timeclock_inline_svg__XMLID_9807_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "timeclock_inline_svg__XMLID_9808_",
    d: "M34.7 15.8c-3 0-5.4 2.4-5.4 5.4s2.4 5.4 5.4 5.4c3 0 5.4-2.4 5.4-5.4s-2.4-5.4-5.4-5.4zm0 8.9c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.5 3.5-3.5 3.5z",
    className: "timeclock_inline_svg__st1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "timeclock_inline_svg__XMLID_9812_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "timeclock_inline_svg__XMLID_9813_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "timeclock_inline_svg__XMLID_9814_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "timeclock_inline_svg__XMLID_9815_",
    d: "M34.5 22.2h-.2c-.2-.1-.3-.3-.3-.4v-2.9c0-.3.2-.5.5-.5s.5.2.5.5v1.7l.7-.7c.2-.2.5-.2.7 0 .2.2.2.5 0 .7l-1.5 1.5c-.1.1-.2.1-.4.1z",
    className: "timeclock_inline_svg__st1"
  }))))))));
};
export default SvgTimeclockinline;